import { render, staticRenderFns } from "./create_team.vue?vue&type=template&id=4f89b0de&"
import script from "./create_team.vue?vue&type=script&lang=js&"
export * from "./create_team.vue?vue&type=script&lang=js&"
import style0 from "./create_team.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "create_team.vue"
export default component.exports